let config = {
    title: `Oni Hunter: Soul Rekindled`,
    copyright: '© 2026 Boug.apps',
    email: 'bilominacer3@gmail.com',
    policy: 'https://app.breathofslayer.com/privacy_policy',
    term: 'https://app.breathofslayer.com/terms.html',
    introduceTitle: [
        `Whispers of the Sun is calling. Will you answer, or will you let destiny pass you by?`,
        `Step into a world where ancient legends and powerful beings clash in an epic struggle for survival. This is your chance to lead a band of extraordinary warriors, collecting and enhancing each one to forge an unstoppable force. Experience a saga brimming with emotional intensity, tactical depth, and stunning visual artistry that will captivate your senses.`,
        `What are you waiting for? Every moment you hesitate is a moment lost from assembling your ultimate team and claiming your rightful place among legends.`
    ],
    introduceText: [
        {
            title: '',
            text: [
                `• AN EPIC ROSTER AWAITS: Gather an expansive collection of unique heroes, each with distinct powers and backstories. Unleash elemental attacks, master blade techniques, and command spirit arts. Your ultimate team is just a summon away. The more you collect, the more unstoppable you become! Don't miss the chance to collect rare heroes as they become available.`
            ]
        },
        {
            title: '',
            text: [
                `• STRATEGY IS KEY: Engage in strategic, turn-based combat where clever team compositions and timely skill activations are paramount. Plan your attacks, defend your allies, and turn the tide of battle with precision. Every decision makes a difference. Don't miss out on mastering the battlefield and showing off your tactical prowess!`
            ]
        },
        {
            title: '',
            text: [
                `• ASCEND TO GREATNESS: Boost your heroes through a comprehensive progression system. Unlock new abilities, enhance stats, and awaken their latent potential. The journey from novice to legend is long, but the power you'll wield is unmatched. Start empowering your team now before the forces of darkness grow too strong!`
            ]
        },
        {
            title: '',
            text: [
                `• A WORLD OF STORIES: Dive into a beautifully animated world rendered with breathtaking detail. Discover a rich narrative filled with intrigue, sacrifice, and the bonds that tie heroes together. Unravel the mysteries of ancient traditions and face down formidable adversaries. Don't let this incredible story pass you by.`
            ]
        },
        {
            title: '',
            text: [
                `• CHALLENGE GLOBAL PLAYERS: Join forces with friends or compete against challengers from across the globe in exciting PvP and co-op modes. Rise through the ranks, earn exclusive rewards, and establish your dominance. Your legend begins today; don't be left behind in the shadows! The leaderboard waits for no one.`
            ]
        },
        {
            title: '',
            text: [
               `This isn't just a game; it's an experience. The world is calling for a hero.`
            ]
        }
    ]
}
export default config;